import {
  AnalyticsEvent,
  InlineAlertType,
  Mutation,
  Typenames,
  VxlSystemBanner,
} from '@varo/graphql-schema-types';
import { Href, useRouter } from 'expo-router';
import React from 'react';
import { parseGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import DismissPinwheelPageAlert from 'services/graphql/mutations/DirectDeposit/DismissPinwheelPageAlert';
import InlineAlert from 'shared/components/vxl/InlineAlert/InlineAlert';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { useMutation } from 'urql';

interface PayrollProviderLinkAlertProps {
  alert: VxlSystemBanner;
  onDismissed?: () => void;
}

const PayrollProviderLinkAlert = ({
  alert,
  onDismissed,
}: PayrollProviderLinkAlertProps) => {
  const router = useRouter();
  const [, executeMutation] = useMutation<Mutation>(DismissPinwheelPageAlert);

  const { segmentClient } = useAnalyticsConfiguration();

  const handleDismiss = async () => {
    const result = await executeMutation({
      input: { alertIds: [alert.dismissId] },
    });

    if (
      result.data?.dismissPinwheelPageAlert?.__typename ===
      Typenames.DismissPinwheelPageAlertSuccess
    ) {
      onDismissed?.();
    }
  };

  const handleButtonPress = () => {
    if (
      alert.buttonAction?.__typename === Typenames.RouteNavigationAction &&
      alert.buttonAction.route
    ) {
      const { name, properties } = parseGQLAnalyticsEvent(
        alert.buttonAction.analyticsEvent as AnalyticsEvent,
      );
      void segmentClient.logEvent(name, properties);
      router.push(alert.buttonAction.route as Href);
    }
  };

  return (
    <InlineAlert
      titleText={alert.title ?? ''}
      bodyText={alert.body ?? ''}
      alertType={alert.type as unknown as InlineAlertType}
      isImageVisible={true}
      iconKeyType={alert.iconV2}
      onDismiss={alert.dismissId ? handleDismiss : undefined}
      button={
        alert.buttonTitle
          ? {
              label: alert.buttonTitle,
              type: 'SECONDARY_ALT',
              size: 'SMALL',
              width: 'HUG',
              onPress: handleButtonPress,
            }
          : undefined
      }
    />
  );
};

export default PayrollProviderLinkAlert;
